
export default {
    'bl': {
        'Страны': 'Краіны',
        'Города': 'Гарады',
        'Регионы': 'Рэгіёны',
        'Другой город': 'Іншы горад',
        'Выбрать другой город': 'Выбраць іншы горад'
    },
    'ua': {
        'Страны': 'Країни',
        'Города': 'Міста',
        'Регионы': 'Регіони',
        'Другой город': 'Інше місто',
        'Выбрать другой город': 'Вибрати інше місто'
    },
    'kk': {
        'Страны': 'Елдер',
        'Города': 'Қалалар',
        'Регионы': 'Аймақтар',
        'Другой город': 'Басқа қала',
        'Выбрать другой город': 'Басқа қаланы таңдаңыз'
    },
    'ru': {
        'Страны': 'Страны',
        'Города': 'Города',
        'Регионы': 'Регионы',
        'Другой город': 'Другой город',
        'Выбрать другой город': 'Выбрать другой город'
    },
    'en': {
        'Страны': 'Countries',
        'Города': 'Cities',
        'Регионы': 'Provinces',
        'Другой город': 'Another city',
        'Выбрать другой город': 'Choose another city'
    }
};